<template>
  <v-card>
    <div style="position: relative;" class="mt-3">
      <h1 class="text-pagename text-xs-center">Request cash (All province)</h1>
      <v-btn
        flat
        color="info"
        style=";position:absolute;top:0px;right:10px;"
        @click="$router.push({ name: 'log-requestcash' })"
      >
        <span> see log</span></v-btn
      >
    </div>
    <requestCash :request_cash="request_cash" />
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import requestCash from "@/components/back-office/Rider/RequestCash/RequestCashTable";
export default {
  data() {
    return {};
  },
  components: {
    requestCash,
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Rider",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/rider/riderinhouse",
        // href: '/weserve_admin_login/control/' + this.$route.params.province + '/rider/riderdashboard'
      },
      {
        text: "Request cash",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  created() {},
  computed: {
    ...mapState({
      request_cash: (state) => state.fetchCashRider.cash_request,
    }),
  },
};
</script>
